import { del } from 'libs/GrebbCommerceAPI/util';

export default async basketId => {
    return await del(`/basket/${basketId}/items`, []);
};
